module.exports = "https://web-assets.ifttt.com/packs/media/header/icon-avatar-5d8d838b.svg";